<a nz-popconfirm [nzPopconfirmTitle]="'Common.ConfirmDeleteMessage' | translate" [nzOkText]="'Common.OK' | translate" [nzCancelText]="'Common.Cancel' | translate" (nzOnConfirm)="confirm.emit()"
    nzPopconfirmPlacement="bottom">
    <button nzType="link" nz-button [nzTooltipTitle]="'Common.Delete' | translate" nz-tooltip  nzTooltipPlacement="topLeft">
        <span>{{'Common.Delete' | translate}}</span>
    </button>
</a>